import ApiService from './ApiService';
import { Message } from '@/models';

function createMessage(messageData: Message) {
  return ApiService.post('/parse/classes/Message', messageData);
}

function createSMSMessage(messageData: any) {
  return ApiService.postV2('/chats/v1/messages', messageData);
}

const MessageService = {
  createMessage,
  createSMSMessage,
};

export default MessageService;
